import React, { Fragment } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import StyledChip from "./elements/StyledChip";
import { FileStatus } from "../constants/FileStatus";
import File from "./elements/File";
import {
  Data,
  HeaderCellStyle,
  StyledTableWrapper,
  EligibleModuleWrapper,
} from "./styled/StyledTable.styled";
import { IconButton, Tooltip } from "@mui/material";
import {
  BiUpArrowAlt,
  BiDownArrowAlt,
  BiEdit,
  BiWindowAlt,
} from "react-icons/bi";
import { IoEarth } from "react-icons/io5";
import { StyledSwitch } from "./styled/StyledSwitch.styled";
import { RiDeleteBin6Line } from "react-icons/ri";
import StyledCheckBox from "./elements/StyledCheckBox";
import LoaderFade from "./elements/LoaderFade";
import Loader from "./elements/Loader";
import { WEB_MAP, WEB_PORTAL,EDOTCO_SITE,
  OPERATOR_SITE } from "../constants/AppPermissionModels";
import { errorRemarks } from "../constants/Data";

function EnhancedTableHead(props) {
  const {
    headCells,
    order,
    setOrder,
    action,
    select,
    allCheck,
    selectAll,
    edit,
  } = props;
  const handleChangeSort = (id) => {
    setOrder({ id: id, sort: order.sort === "asc" ? "dsc" : "asc" });
  };
  const handleChangeId = (id) => {
    setOrder({ id: id, sort: "asc" });
  };

  return (
    <TableHead>
      <TableRow>
        {select && (
          <TableCell align={"center"} sx={{ width: "200px", padding: "10px" }}>
            <HeaderCellStyle>
              <StyledCheckBox checked={selectAll} onChange={allCheck} />
              Select User
            </HeaderCellStyle>
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            sx={{ width: "fit-content", padding: "10px" }}
          >
            <HeaderCellStyle key={`headCell${headCell.id}`}>
              {headCell.label}
              {headCell.sorting && (
                <Fragment>
                  {order.id === headCell.id ? (
                    <IconButton
                      onClick={() => {
                        handleChangeSort(headCell.id);
                      }}
                    >
                      {order.sort === "asc" && (
                        <BiUpArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                      {order.sort === "dsc" && (
                        <BiDownArrowAlt
                          style={{
                            fontSize: "14px",
                            color: "black",
                          }}
                        />
                      )}
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        handleChangeId(headCell.id);
                      }}
                    >
                      <BiUpArrowAlt
                        style={{
                          fontSize: "14px",
                          opacity: "0.5",
                        }}
                      />
                    </IconButton>
                  )}
                </Fragment>
              )}
            </HeaderCellStyle>
          </TableCell>
        ))}
        {action && (
          <TableCell
            align={"center"}
            sx={{ maxWidth: "200px", padding: "10px" }}
          >
            <HeaderCellStyle>{edit ? "Edit" : "Action"}</HeaderCellStyle>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable({
  headCells,
  editClick,
  deleteClick,
  rows,
  chips,
  files,
  order,
  output,
  loading,
  setOrder,
  onOutputFileClick,
  onFileClick,
  clickSwitch,
  slider,
  deleteEnabaled,
  select,
  action,
  allCheck,
  selectAll,
  onClickUser,
  template,
  edit,
  isEdit = true,
  ...props
}) {
  const getChipColorBasedOnFileStatus = (status) => {
    if (status === FileStatus.SUCCESS) {
      return "success";
    }
    if (status === FileStatus.PENDING || status === "pending") {
      return "warning";
    }
    if (status === FileStatus.ERROR || status === "rejected") {
      return "error";
    }
  };
  const user = JSON.parse(localStorage.getItem("user"));

  const isUploadErrorRemark = (remark) => {
    if (!remark) return false;
    if (errorRemarks.includes(remark.trim().replace(/ /g, '_'))) return true;
    return false;
  }
  return (
    <StyledTableWrapper>
      <TableContainer>
        <Table
          sx={{ minWidth: "100px", padding: "10px" }}
          aria-labelledby="tableTitle"
        >
          {loading ? (
            <>
              <Loader />
            </>
          ) : (
            <>
              <EnhancedTableHead
                headCells={headCells}
                order={order}
                setOrder={setOrder}
                action={action}
                select={select}
                allCheck={allCheck}
                selectAll={selectAll}
                edit={edit}
              />
              <TableBody>
                {rows?.map((row, index) => {
                  const labelId = `enhanced-table-row-${index}`;
                  return (
                    <TableRow key={labelId} hover>
                      {select && (
                        <TableCell align={"center"}>
                          <StyledCheckBox
                            checked={row.select}
                            onChange={() => {
                              onClickUser({ ...row, select: !row.select });
                            }}
                          />
                        </TableCell>
                      )}
                      {Object.keys(row).map((key) => {
                        if (key === slider) {
                          return (
                            <TableCell align={"left"} sx={{ width: "50px" }}>
                              <StyledSwitch
                                disabled={user._id === row["id"] ? true : false}
                                checked={row[key]}
                                onClick={() => {
                                  clickSwitch(row);
                                }}
                              />
                            </TableCell>
                          );
                        }
                        if (key === "id") {
                          return null;
                        }
                        if (key === chips) {
                          return (
                            <TableCell
                              align={"left"}
                              sx={{
                                maxWidth: "200px",
                                minWidth: "80px",
                                overflowWrap: "break-word",
                              }}
                            >
                              <StyledChip
                                label={row[key]}
                                color={getChipColorBasedOnFileStatus(row[key])}
                              />
                            </TableCell>
                          );
                        }
                        if (key === "url") {
                          return null;
                        }
                        if (key === files) {
                          return (
                            <TableCell
                              align={"left"}
                              sx={{
                                maxWidth: "200px",
                                minWidth: "80px",
                                overflowWrap: "break-word",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              <File
                                disabled={row.status === "error" && isUploadErrorRemark(row.remark)}
                                fileName={template ? row[key] : "data.xlsx"}
                                upload={key === "uploaded_file" ? true : false}
                                handleClick={() => {
                                  onFileClick({
                                    id: row["id"],
                                    name: row[key],
                                    data: row,
                                  });
                                }}
                              />
                            </TableCell>
                          );
                        }
                        if (key === output) {
                          return (
                            <TableCell
                              align={"left"}
                              sx={{
                                maxWidth: "200px",
                                minWidth: "80px",
                                overflowWrap: "break-word",
                              }}
                            >
                              {row.status === "processing" ? <>N/A</> : <></>}
                              {row.status === "error" ? (
                                <>{row.remark}</>
                              ) : (
                                <></>
                              )}
                              {row.status === "success" ? (
                                <>
                                  <File
                                    fileName={"Download"}
                                    zip
                                    handleClick={() => {
                                      onOutputFileClick({
                                        id: row["id"],
                                        name: row[key],
                                      });
                                    }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                          );
                        }
                        if (key === "remark") {
                          return null;
                        }
                        return (
                          <Fragment>
                            {typeof row[key] === "string" && (
                              <Fragment>
                                {key === "user_id" ? 
                                <></> 
                                :
                                  <TableCell
                                    align={"left"}
                                    sx={{
                                      maxWidth: "200px",
                                      minWidth: "100px",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    <Data>{row[key]}</Data>
                                  </TableCell>
                                }
                              </Fragment>
                            )}
                            {Array.isArray(row[key]) && (
                              <Fragment>
                                <TableCell
                                  align={"left"}
                                  sx={{
                                    maxWidth: "200px",
                                    minWidth: "100px",
                                    overflowWrap: key !== "group_name" ? "break-word" : "anywhere",
                                  }}
                                >
                                  <Data>
                                    {key !== "group_name" && (
                                      <>
                                        {row[key].length === 0 &&
                                        row.user_role === "Admin" &&
                                        "All Modules"}
                                        {row[key].length === 0 &&
                                          row.user_role === "Super Admin" &&
                                          "All Modules"}
                                        {row[key].length === 0 &&
                                          row.user_role === "User" &&
                                          "No Allocation"}
                                        {row[key].length === 0 &&
                                          row.user_role === "Reporting" &&
                                          "No Allocation"}
                                      </>
                                    )} 
                                    <EligibleModuleWrapper>
                                    {row[key]
                                      .filter(
                                        (x) =>
                                          x.name?.length > 0 || x.length > 0
                                      )
                                      .map((item, index) => {
                                        if (item === WEB_PORTAL)
                                          return (
                                            <Tooltip
                                              title={WEB_PORTAL}
                                              placement="top"
                                            >
                                              <div style={{width:"20%"}}>
                                                <BiWindowAlt style={{width:"22px",height:"22px"}}/>
                                              </div>
                                            </Tooltip>
                                          );
                                        else if (item === WEB_MAP)
                                          return (
                                            <Tooltip
                                              title={WEB_MAP}
                                              placement="top"
                                            >
                                              <div style={{width:"20%"}}>
                                                <IoEarth style={{width:"22px",height:"22px"}} />
                                              </div>
                                            </Tooltip>
                                          );
                                        else if (item === EDOTCO_SITE || item === OPERATOR_SITE){
                                          return null;
                                        }
                                        else {
                                          if (
                                            index ===
                                            row[key].filter(
                                              (x) =>
                                                x.name?.length > 0 ||
                                                x.length > 0
                                            ).length -
                                              1
                                          )
                                            return <>{item.name || item}</>;
                                          return <>{item.name || item}, </>;
                                        }
                                      })}
                                    </EligibleModuleWrapper>
                                  </Data>
                                </TableCell>
                              </Fragment>
                            )}
                          </Fragment>
                        );
                      })}
                      {action && (
                        <TableCell
                          align={"center"}
                          xs={{ maxWidth: "10px", display: "flex" }}
                        >
                          {isEdit && (
                            <IconButton
                              disabled={user._id === row["id"] ? true : false}
                              color="primary"
                              onClick={() => {
                                editClick(row);
                              }}
                              data-testid="EnhancedTable-edit-btn-test"
                            >
                              <BiEdit />
                            </IconButton>
                          )}
                          {deleteEnabaled && (
                            <IconButton
                              disabled={user._id === row["id"] ? true : false}
                              color="error"
                              onClick={() => {
                                deleteClick(row);
                              }}
                            >
                              <RiDeleteBin6Line />
                            </IconButton>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </>
          )}
        </Table>
      </TableContainer>
    </StyledTableWrapper>
  );
}
